import React from 'react'
import Home from '../../componentsGeneral/componentsSuperUser/home/Home'

const HomeSuperUser = () => {
  return (
    <div>
        <Home/>
    </div>
  )
}

export default HomeSuperUser